module.exports = __webpack_public_path__ + "static/img/ck1.e39a73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/ck1.png
// module id = 307
// module chunks = 0